import React from "react";
import PropTypes from "prop-types";
import { Icon } from "semantic-ui-react";
import "./index.css";

function OverlayIcon({ name, size }) {
  return (
    <div className="overlay-icon">
      <Icon name={name} size={size} />
    </div>
  );
}

OverlayIcon.propTypes = {
  size: PropTypes.oneOf(["mini", "tiny", "small", "medium", "large", "big", "huge", "massive"]),
  name: PropTypes.string.isRequired,
};

export default OverlayIcon;



// WEBPACK FOOTER //
// ./src/components/OverlayIcon/index.js